import React, { useEffect, useState } from "react";
import ClsUnloadingIns from "./ClsUnloadingIns";
import axios from "axios";

const ClsUnloadingInsMaster = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [from, setFrom] = useState([]);
  const [to, setTo] = useState([]);
  const [backload, setBackload] = useState([]);
  const [commodity, setCommodity] = useState([]);
  const [rakeType, setRaketype] = useState([]);
  const [bpcic, setBpcic] = useState([]);
  const [bpcType, setbpctype] = useState([]);
  const [interChange, setInterChange] = useState([]);
  const fetchMasterData = async (tableName, setter) => {
    try {
      const response = await axios.get(
        `${urlPrefix}allMasterData?table_name=${tableName}`,
      );

      if (response.data.success) {
        setter(response.data.data);
      }
    } catch (error) {
      console.error(`Failed to fetch ${tableName}:`, error);
      setError(true);
    }
  };

  const fetchBackload = async () => {
    try {
      const response = await axios.get(
        `${urlPrefix}getMultipleTableData?hdr_table=t_indent_hdr&dtl_table=t_indent_dtls&hdr_pk=id&dtl_fk=ind_id&action=pending`,
      );

      if (response.data.success) {
        setBackload(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch backload:", error);
      setError(true);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);

      await Promise.all([
        fetchBackload(),
        fetchMasterData("m_stations_sidings_useable", setTo),
        fetchMasterData("m_commodity", setCommodity),
        fetchMasterData("m_wagons", setRaketype),
        fetchMasterData("m_bpc_stn", setBpcic),
        fetchMasterData("m_bpc_type", setbpctype),
        fetchMasterData("cls_interchange_station", setInterChange),
      ]);

      setLoading(false);
    };

    loadData();
  }, []);
  const Data = backload.map((item) => ({
    ...item.hdr_data,
    siding: item.dtl_data
      .filter((d) => d.pick_drop_flag === "S")
      .map((d) => d.pick_drop_point)
      .join(" + "),
    destination: item.dtl_data
      .filter((d) => d.pick_drop_flag === "D")
      .map((d) => d.pick_drop_point)
      .join(" + "),
  }));

  return (
    <div style={{ minHeight: "90vh" }} className="papaDiv">
      <ClsUnloadingIns
        backload={Data}
        to={[
          ...new Set(
            to
              .filter((o) => o.G_and_S_flag === "G" || o.G_and_S_flag === "S")
              .map((o) => o.sdng_goods_list),
          ),
        ]}
        from={[
          ...new Set(
            to
              .filter(
                (o) =>
                  o.loading_Unloading === "Unloading" ||
                  o.loading_Unloading === "Both",
              )
              .map((o) => o.station_code),
          ),
        ]}
        commodity={[...new Set(commodity.map((o) => o.rake_commodity))]}
        rakeType={[...new Set(rakeType.map((o) => o.rake_typ))]}
        bpcic={bpcic.map((o) => o.bpc_stn)}
        bpcType={bpcType.map((o) => o.type_of_bpc)}
        InterChange={interChange.map((o) => o.station_code)}
      />
    </div>
  );
};
export default ClsUnloadingInsMaster;
